import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chuku",
  "use": "icon-chuku-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chuku\"><defs><style type=\"text/css\"></style></defs><path d=\"M823.2 384H704V224c0-17.6-14.4-32-32-32H96c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h32c0 70.4 57.6 128 128 128s128-57.6 128-128h256c0 70.4 57.6 128 128 128s128-57.6 128-128h32c17.6 0 32-14.4 32-32V581.6c0-3.2-0.8-6.4-2.4-8.8l-120.8-181.6c-3.2-4.8-8-7.2-13.6-7.2zM268.8 766.4c-44.8 8.8-84-30.4-75.2-75.2 4.8-24.8 24.8-45.6 50.4-50.4 44.8-8.8 84 30.4 75.2 75.2-5.6 25.6-25.6 45.6-50.4 50.4z m512 0c-44.8 8.8-84-30.4-75.2-75.2 4.8-24.8 24.8-45.6 50.4-50.4 44.8-8.8 84 30.4 75.2 75.2-5.6 25.6-25.6 45.6-50.4 50.4zM704 576V448h95.2c5.6 0 10.4 2.4 12.8 7.2L896 576H704z\" p-id=\"4938\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chuku.svg
// module id = hm+4
// module chunks = 87